module.exports = __webpack_public_path__ + "img/Cambodia.db4cfe62.svg";